module.exports = __webpack_public_path__ + "media/images/lb/072-1c196911c7f67d3f43d6208fd595df9a.svg";